<template>
    <div>
        <!-- while we fetch the list of formats from the server, lets show a small spinner -->
        <div class="text-left" v-if="loading">
            <span class="loading_animation">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.54547 5.99998C3.54547 5.69875 3.30125 5.45453 3.00002 5.45453H0.818192C0.516954 5.45453 0.272736 5.69875 0.272736 5.99998C0.272736 6.30122 0.516954 6.54544 0.818192 6.54544H3.00002C3.30125 6.54544 3.54547 6.30122 3.54547 5.99998Z"
                      fill="black"></path>
                <path d="M11.1818 5.45453H10.0909C9.78969 5.45453 9.54547 5.69875 9.54547 5.99998C9.54547 6.30122 9.78969 6.54544 10.0909 6.54544H11.1818C11.4831 6.54544 11.7273 6.30122 11.7273 5.99998C11.7273 5.69875 11.4831 5.45453 11.1818 5.45453Z"
                      fill="black"></path>
                <path d="M6.27273 3.27273C6.57397 3.27273 6.81819 3.02851 6.81819 2.72727V0.545455C6.81819 0.244218 6.57397 0 6.27273 0C5.9715 0 5.72728 0.244218 5.72728 0.545455V2.72727C5.72728 3.02851 5.9715 3.27273 6.27273 3.27273Z"
                      fill="black"></path>
                <path d="M6.27278 8.72726C5.97154 8.72726 5.72733 8.97148 5.72733 9.27272V11.4545C5.72733 11.7558 5.97154 12 6.27278 12C6.57402 12 6.81823 11.7558 6.81823 11.4545V9.27272C6.81823 8.97148 6.57402 8.72726 6.27278 8.72726Z"
                      fill="black"></path>
                <path d="M2.80146 1.75735C2.58852 1.54433 2.24314 1.54436 2.03008 1.75735C1.81706 1.97036 1.81706 2.31571 2.03008 2.52873L3.57289 4.07156C3.67939 4.17807 3.819 4.23135 3.95856 4.23135C4.09812 4.23135 4.23776 4.17807 4.34423 4.0716C4.55725 3.85858 4.55725 3.51324 4.34423 3.30022L2.80146 1.75735Z"
                      fill="black"></path>
                <path d="M8.97259 7.92851C8.75961 7.71552 8.41423 7.71552 8.20121 7.92851C7.98819 8.14153 7.98823 8.48688 8.20121 8.6999L9.74404 10.2427C9.85055 10.3492 9.99015 10.4024 10.1298 10.4024C10.2694 10.4024 10.409 10.3491 10.5154 10.2427C10.7284 10.0297 10.7284 9.68431 10.5154 9.47129L8.97259 7.92851Z"
                      fill="black"></path>
                <path d="M3.57289 7.9285L2.03012 9.47128C1.81711 9.6843 1.81711 10.0297 2.03012 10.2427C2.13663 10.3492 2.27623 10.4024 2.41583 10.4024C2.55543 10.4024 2.69503 10.3492 2.80151 10.2427L4.34427 8.69989C4.55729 8.48687 4.55729 8.14152 4.34427 7.9285C4.13125 7.71548 3.78587 7.71548 3.57289 7.9285Z"
                      fill="black"></path>
            </svg>
       </span>
        </div>

        <div v-if="!loading">

            <!-- select which format we should validate against -->
            <select class="form-control" @change="onFormatChange($event.target.value)">
                <option value="" v-if="!is_required">{{t('ssn_select_format')}}</option>
                <option v-for="(format, index) in formats" :value="format.type"
                        :selected="format.type == social_security_number_type">
                    {{ format.extended_title }}
                </option>
            </select>

            <!-- if the selected format required nationality, show the country selector -->
            <div v-if="is_country_required">
                <CountrySelectInput
                        :placeholder="t('please_specify_nationality')"
                        :selected="selected_nationality"
                        :language="language"
                        @select="onNationalityChange"
                        required></CountrySelectInput>
            </div>

            <!-- show social security number input. (This might be hidden until the user has selected nationality) -->
            <div class="validate-ssn-input" v-if="is_social_security_number_input_visible">
                <input type="text" class="form-control" id="inputSSN" @input="validate()"
                       :placeholder="t('profile_ssn')"
                       v-model="social_security_number" required>

                <!-- icons overlay to show validation status -->
                <div class="validate-icons">

                    <!-- valid -->
                    <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"
                         v-if="valid">
                        <circle cx="11" cy="11" r="11" fill="#45B164"></circle>
                        <path d="M7 10.6667L9.66667 13.9259L15 8" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                    </svg>

                    <!-- not valid but something is entered-->
                    <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"
                         v-if="!valid && social_security_number">
                        <circle cx="11" cy="11" r="11" fill="#F73238"></circle>
                        <path d="M7.99999 14L9.95317 12.183L14 8" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                        <path d="M8 7.99999L9.817 9.95317L14 14" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                    </svg>

                    <!-- not valid and the input is blank-->
                    <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"
                         v-if="!valid && !social_security_number">
                        <circle cx="11" cy="11" r="11" fill="#ccc"></circle>
                        <path d="M7.99999 14L9.95317 12.183L14 8" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                        <path d="M8 7.99999L9.817 9.95317L14 14" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                    </svg>
                </div>
            </div>

            <!-- user validation feedback -->
            <div class="small" v-if="is_descriptions_visible">


                <!-- ssn validation validation_errors -->
                <div class="alert alert-custom-danger text-left mt-1" v-for="error in validation_errors">
                    <svg class="warning-icon" width="18" height="15" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.1896 12.5178H10.2106L10.0719 8.40196H11.3283L11.1896 12.5178ZM10.7001 13.1623C10.8986 13.1623 11.0577 13.2208 11.1773 13.3377C11.2997 13.4547 11.3609 13.6042 11.3609 13.7864C11.3609 13.9659 11.2997 14.1141 11.1773 14.2311C11.0577 14.348 10.8986 14.4065 10.7001 14.4065C10.5043 14.4065 10.3452 14.348 10.2228 14.2311C10.1032 14.1141 10.0433 13.9659 10.0433 13.7864C10.0433 13.6069 10.1032 13.4587 10.2228 13.3418C10.3452 13.2221 10.5043 13.1623 10.7001 13.1623Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.63597 16.1164H17.8409L10.7384 4.05295L3.63597 16.1164ZM20.2155 17.9961C20.6194 17.9961 20.8704 17.5571 20.6655 17.2091L11.1884 1.11233C10.9864 0.769361 10.4904 0.769361 10.2885 1.11233L0.811418 17.2091C0.60649 17.5571 0.857443 17.9961 1.26136 17.9961H20.2155Z" fill="black"/>
                    </svg>
                    {{ error }}
                </div>

                <!-- format explanation -->
                <div v-if="selected_format && selected_format.explanation && !valid"
                     class="alert alert-custom-info text-left">
                    <svg class="info-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14.3636C11.5145 14.3636 14.3636 11.5145 14.3636 8C14.3636 4.48546 11.5145 1.63636 8 1.63636C4.48546 1.63636 1.63636 4.48546 1.63636 8C1.63636 11.5145 4.48546 14.3636 8 14.3636ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="black"/>
                        <path d="M9.25891 12.0909H6.75854C6.64509 12.0909 6.58836 12.0385 6.58836 11.9338V11.3709C6.58836 11.2662 6.64509 11.2138 6.75854 11.2138H7.47854V6.52727H6.75854C6.64509 6.52727 6.58836 6.47491 6.58836 6.37018V5.80727C6.58836 5.70254 6.64509 5.65018 6.75854 5.65018H8.408C8.51273 5.65018 8.56509 5.70254 8.56509 5.80727V11.2138H9.25891C9.37236 11.2138 9.42909 11.2662 9.42909 11.3709V11.9338C9.42909 12.0385 9.37236 12.0909 9.25891 12.0909ZM8.51273 3.71272C8.66109 3.86109 8.73527 4.03563 8.73527 4.23636C8.73527 4.43709 8.66109 4.60727 8.51273 4.74691C8.37309 4.88654 8.20291 4.95636 8.00218 4.95636C7.80145 4.95636 7.62691 4.88654 7.47854 4.74691C7.33891 4.60727 7.26909 4.43709 7.26909 4.23636C7.26909 4.03563 7.33891 3.86109 7.47854 3.71272C7.62691 3.56436 7.80145 3.49018 8.00218 3.49018C8.20291 3.49018 8.37309 3.56436 8.51273 3.71272Z" fill="black"/>
                    </svg>
                    <div class="text-left">
                        <span class="text-capitalize">{{ t('format')}}</span> {{ format_string_human_readable }}
                    </div>
                    <span style="display:inline-block;white-space: nowrap;padding-right:5px;"
                          v-for="(value, key ) in selected_format.explanation">
                       {{key}} = {{value}}.
                  </span>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import CountrySelectInput from "./CountrySelectInput";

    /*
    *
    * Supports v-model
    *
    * Events:
    *   'nationality-change' : whenever nationality option select has changed. returns the identifier.
    *   'format-change' : whenever format option select has changed. returns the identifier.
    *   'validity-change' : whenever validation state has changed, after serverside validation. returns true or false.
    *   'input' : whenever social security number changes, after serverside validation. returns social security number or empty string.
    * */


    export default {
        name: "SocialSecurityNumberInput",
        components: {CountrySelectInput},
        props: {
            value: {
                type: String,
                default: ''
            },
            formatType: {
                type: String,
                default: ''
            },
            language: {
                type: String,
                default: 'no'
            },
            nationality: {
                default: ''
            },
            required: {
                default: null
            }
        },
        data: function () {
            return {
                formats: [],
                selected_format: null,
                selected_nationality: this.nationality,
                social_security_number: this.value,
                social_security_number_type: this.formatType,
                validation_errors: [],
                valid: false,
                loading: false,
            }
        },
        methods: {
            t: function (key) {
                return this.$phrasePlugin.translate(key);
            },
            setSelectedFormatFromType: function () {
                this.selected_format = this.formats.find(format => format.type === this.social_security_number_type);
            },
            onFormatChange: function (format_type) {
                this.social_security_number_type = format_type;
                this.setSelectedFormatFromType();
                this.validate();
                this.$emit('format-change', this.selected_format ? this.selected_format.type : null);
            },
            onNationalityChange: function (id) {
                this.$emit('nationality-change', id);
                this.validate();
            },
            // Note that this method will only emit the national identification number / social security number
            // if the number is considered valid.
            setValidity: function (valid) {
                this.valid = valid;
                this.$emit('input', this.valid ? this.social_security_number : '' );
                this.$emit('validity-changed', this.valid);
            },
            // validate() method is created in the created lifecycle.
            hasRequiredNationalityInformation : function(){
              return this.selected_format && this.selected_format.country_required && !this.nationality;
            },
            fetch: function () {
                // Fetch the list of national identification social_security_number formats
                this.loading = true;

                axios({
                    method: 'get',
                    url: 'validation/ssn/formats?language_id=' + this.language,
                }).then(function (response) {
                    this.formats = response.data;

                    // If we dont have a type we will use the first in the list if its required, otherwise we will leave it blank/null.
                    if (!this.social_security_number_type) {
                        this.selected_format = this.is_required ? this.formats[0] : null;
                        this.social_security_number_type = this.selected_format.type;
                    } else {
                        this.selected_format = this.formats.find(format => format.type === this.social_security_number_type);
                    }
                    this.loading = false;

                    // Revalidate to get the translated error messages.
                    this.validate();
                }.bind(this))
                    .catch(e => {
                        console.warn(e);
                        this.loading = false;
                    });
            }
        },
        computed: {
            is_required() {
                return this.required === 'true' && this.required !== null;
            },
            is_country_required() {
                return this.selected_format ? this.selected_format.country_required : false;
            },
            format_string_human_readable() {
                return this.selected_format ? this.selected_format.format : '';
            },
            is_descriptions_visible() {
                return this.is_social_security_number_input_visible || this.social_security_number_type;
            },
            is_social_security_number_input_visible() {
                return this.social_security_number || (this.social_security_number_type && (!this.is_country_required || (this.is_country_required && this.selected_nationality)));
            }
        },
        watch: {
            language: function () { //newVal, oldVal
                this.fetch();
                this.validate(); //Generates translated errors
            },
            nationality: function (newVal, oldVal) { //
               this.selected_nationality = newVal;
                this.validate();
            }
        },
        created: function () {
            this.fetch();

            // Not a mistake : https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2
            this.validate = _.debounce(function () {
                if (!this.social_security_number) {
                    this.validation_errors = [];
                    this.setValidity(false);
                } else {
                    if (this.social_security_number_type) {

                        if (this.hasRequiredNationalityInformation()) {
                            this.setValidity(false);
                            this.validation_errors = [this.t('please_specify_nationality')];
                        } else {
                            axios({
                                method: 'get',
                                url: 'validation/ssn?format_type=' + this.social_security_number_type + '&number=' + this.social_security_number + '&language_id=' + this.language,
                            }).then(function (response) {
                                if ('errors' in response.data) {
                                    this.validation_errors = response.data.errors;
                                }
                                this.setValidity(response.data.valid);
                            }.bind(this))
                                .catch(e => {
                                    this.validation_errors.push(e)
                                });
                        }

                    }
                }
            }, 500);


        }
    }
</script>

<style scoped>
    .validate-ssn-input {
        position: relative;
    }

    .validate-ssn-input input[type=text] {
        padding-right: 33px;
    }

    .validate-ssn-input .validate-icons {
        display: inline-block;
        position: absolute;
        right: 10px;
        top: 5px;
    }

    .alert-custom-danger {
        position: relative;
        background: none;
        border-color: #f5c6cb;
        border-left-width: 40px;
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
    }

    .alert-custom-info {
        position: relative;
        background: none;
        border-color: #bee5eb;
        border-left-width: 40px;
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
    }


    .warning-icon {
        position: absolute;
        left: -30px;
        top: 8px;
        color: #000;
        font-size: 22px;
        opacity: 0.6;
    }

    .info-icon {
        position: absolute;
        left: -30px;
        top: 10px;
        color: #000;
        font-size: 22px;
        opacity: 0.6;
    }

    select {
        appearance: menulist !important;
    }

    .loading_animation {
        display: inline-block;
        animation: spinner .6s linear;
        animation-iteration-count: infinite;
    }

    @keyframes spinner {
        from {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

</style>